export default __webpack_public_path__ + "static/media/2.b3267ce5.png";